import { render, staticRenderFns } from "./DetailsSection.vue?vue&type=template&id=634c10ef&scoped=true&"
import script from "./DetailsSection.vue?vue&type=script&lang=js&"
export * from "./DetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSection.vue?vue&type=style&index=0&id=634c10ef&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634c10ef",
  null
  
)

export default component.exports